import script from "./IconBullet.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconBullet.vue?vue&type=script&setup=true&lang=ts"

import "./IconBullet.vue?vue&type=style&index=0&id=57f7619a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57f7619a"]])

export default __exports__